import React from "react";
import {
  AlignCenterHorizontal,
  AlignCenterVertical,
  AlignEndHorizontal,
  AlignEndVertical,
  AlignStartHorizontal,
  AlignStartVertical,
} from "lucide-react";
import { handleAlignCanvasObject } from "../../../lib/shapes";

const iconsObjects = [
  {
    key: "centerVertically",
    component: AlignCenterHorizontal,
    title: "Center Vertically",
  },
  {
    key: "centerHorizontally",
    component: AlignCenterVertical,

    title: "Center Horizontally",
  },

  {
    key: "alignToTop",
    component: AlignStartHorizontal,
    title: "Align to Top",
  },
  {
    key: "alignToBottom",
    component: AlignEndHorizontal,
    title: "Align to Bottom",
  },
  {
    key: "alignToLeft",
    component: AlignStartVertical,
    title: "Align to Left",
  },
  {
    key: "alignToRight",
    component: AlignEndVertical,
    title: "Align to Right",
  },
];

const ObjectControl = ({
  fabricRef,
  syncShapeInStorage,
  saveStateToHistory,
}: any) => {
  return (
    <section className="flex flex-col border-b border-borderColor">
      <div className="px-2 py-5">
        <div className="mb-2">
          <h3 className="text-[10px] uppercase px-1">Align to Artboard</h3>
        </div>

        <div className="flex flex-row items-center justify-between gap-1">
          {iconsObjects.map((icon) => (
            <div
              key={icon.key}
              title={icon.title}
              className="p-1 rounded hover:bg-black group"
              onClick={() => {
                handleAlignCanvasObject({
                  canvas: fabricRef.current,
                  key: icon.key,
                  syncShapeInStorage,
                  saveStateToHistory,
                });
              }}
            >
              <icon.component
                size={20}
                className="text-body group-hover:cursor-pointer group-hover:text-primary"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ObjectControl;
